import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/reducers';
import { PaginationRequest } from 'src/app/models/common/paginationRequest';
import { Observable } from 'rxjs';
import { AppSessionService } from '../app-session/app-session.service';

@Injectable({
  providedIn: 'root'
})
export class LimitsService {

  private BASE_URL = this.appSession.baseUrl + '/api/v1/limits';

  constructor(private http: HttpClient, private store: Store<AppState>, private appSession: AppSessionService) { }

  // Limit Intervals
  getLimitIntervals(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/x-www-form-urlencoded; ');

    if (pageReq && pageReq.query && (pageReq.query as string).length > 0) {
      headers = headers.set('query', pageReq.query);
    }


    let url = `${this.appSession.baseUrl + '/api/v1/limits'}/limitIntervals`;

    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: 40,
        realSize: false
      };
    }
    const sort = '';
    // const pagination = '?offset=' + pageReq.offset + '&limit=' + pageReq.limit + '&real_size=' + pageReq.realSize;
    const pagination = '?offset=' + pageReq.offset + '&real_size=' + pageReq.realSize;
    url = url.concat(pagination);


    return this.http.get(url, { headers });
  }

  // limitMeasurements
  getLimitMeasurements(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/x-www-form-urlencoded; ');

    if (pageReq && pageReq.query && (pageReq.query as string).length > 0) {
      headers = headers.set('query', pageReq.query);
    }


    let url = `${this.appSession.baseUrl + '/api/v1/limits'}/limitMeasurements`;

    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: 40,
        realSize: false
      };
    }
    const sort = '';
    // const pagination = '?offset=' + pageReq.offset + '&limit=' + pageReq.limit + '&real_size=' + pageReq.realSize;
    const pagination = '?offset=' + pageReq.offset + '&real_size=' + pageReq.realSize;
    url = url.concat(pagination);


    return this.http.get(url, { headers });
  }
}
